import React from "react";
import type { Dispatch } from "redux";
import { connect } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { translate } from "@/modules/shared/IntlProviderWrapper";
import { getPlanningDetailsWidth, getZoomPersistenceSourceType, zoomGanttChart } from "../reducers/gantt/properties";
import ZoomDropdownMenu from "./ZoomDropdownMenu";
import { ZoomMenu } from "./zoomMenu";

import type { ReduxState, ActionTypes } from "../reducers/reducers";

import "./ZoomToolbar.scss";

type OwnProps = {};
type Props = OwnProps & ReduxProps;

type State = {
    showZoomDropdown: boolean;
};

class ZoomToolbar extends React.Component<Props, State> {
    state: State = {
        showZoomDropdown: false,
    };

    toggleZoomDropdown = (isOpen: boolean) => {
        this.setState({ showZoomDropdown: isOpen });
    };

    closeZoomDropdown = () => {
        this.setState({ showZoomDropdown: false });
    };

    getZoomSourceType = () => {
        return getZoomPersistenceSourceType(this.props.source_type);
    };

    getZoomContext = () => {
        return {
            minDayWidth: this.props.properties.min_day_width,
            planningDetailsWidth: getPlanningDetailsWidth(this.props.properties.space_for_label),
        };
    };

    getZoomRange = () => {
        return ZoomMenu.getZoomRange(this.getZoomContext());
    };

    getZoomValue = () => {
        return this.props.properties.width / this.props.properties.days;
    };

    applyZoom = (dayWidth: number) => {
        const constrainedDayWidth = ZoomMenu.constrainDayWidth(dayWidth, this.getZoomRange());
        zoomGanttChart(constrainedDayWidth, this.getZoomSourceType(), this.props.reduxDispatch);
    };

    onClickZoomIn = () => {
        const zoomedValue = ZoomMenu.zoomIn(this.getZoomValue(), this.getZoomRange());
        this.applyZoom(zoomedValue);
    };

    onClickZoomOut = () => {
        const zoomedValue = ZoomMenu.zoomOut(this.getZoomValue(), this.getZoomRange());
        this.applyZoom(zoomedValue);
    };

    /** Same as ZoomDropdownMenu onReset / onClickMonth: restore default month zoom. */
    onClickResetZoom = () => {
        this.applyZoom(ZoomMenu.zoomToMonth(this.getZoomContext()));
    };

    render() {
        return (
            <div className="zoom-toolbar">
                <button className="btn btn-outside-icon" onClick={this.onClickZoomIn}>
                    <i className="fas fa-search-plus fa-lg" />
                </button>
                <button className="btn btn-outside-icon" onClick={this.onClickZoomOut}>
                    <i className="fas fa-search-minus fa-lg" />
                </button>
                <button
                    className="btn btn-outside-icon"
                    type="button"
                    title={translate("common.reset", "Reset")}
                    onClick={this.onClickResetZoom}
                >
                    <i className="fas fa-sync-alt fa-lg" />
                </button>

                <Dropdown show={this.state.showZoomDropdown} onToggle={this.toggleZoomDropdown}>
                    <Dropdown.Toggle
                        as="button"
                        className="btn btn-outside-icon"
                        title={translate("common.tooltip_planningtable_zoom_view", "Zoom view")}
                    >
                        <i className="fas fa-ellipsis-h"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <ZoomDropdownMenu onClose={this.closeZoomDropdown} source_type={this.getZoomSourceType()} />
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }
}

const mapState = (state: ReduxState) => {
    const properties = state.gantt_chart_properties;
    const source_type = state.gantt_chart_properties.source_type;
    return { properties, source_type };
};

const mapDispatch = (dispatch: Dispatch<ActionTypes>) => ({
    reduxDispatch: dispatch,
});

type ReduxProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
export default connect<ReturnType<typeof mapState>, ReturnType<typeof mapDispatch>, OwnProps, ReduxState>(
    mapState,
    mapDispatch
)(ZoomToolbar);
